import { useTranslation } from 'react-i18next';
import { addVat } from '../../../Core/Services/PaymentService';
import Currencies from '../../../Core/Enums/Currencies';
export default function SizeTypeItem({
  key,
  type,
  setSelectedSize,
  selectedSize,
  setSelectedLevel,
}) {
  const { t, i18n } = useTranslation();
  return (
    <div
      onClick={() => {
        setSelectedSizeAndLevel(type);
      }}
      className={`containerListItem !border !border-solid relative p-8 cursor-pointer transition-colors ${
        selectedSize && selectedSize.id === type.id
          ? 'bg-[#F2F5F8] border-[#C6D0E5]'
          : 'border-gray-300 hover:bg-blue-50 hover:border-blue-400'
      }`}
    >
      {type.availableAmount === 0 && (
        <div className="absolute top-0 left-8 text-white bg-black text-sm pl-1 pr-1 pb-[2px] pt-[2px] rounded-b-md">
          {t('sold_out')}
        </div>
      )}
      <div className="flex flex-col justify-start  md:flex-row md:justify-between">
        <div className="font-bold text-lg flex gap-2 items-baseline">
          {type.title}{' '}
          <div
            style={{
              border: '1px solid rgb(191, 75, 48)',
              color: 'rgb(191, 75, 48)',
              padding: '1px 4px',
              fontSize: '12px',
              maxHeight: 'fit-content',
            }}
          >
            {type.isIndoor ? t('indoor') : t('outdoor')}
          </div>
        </div>
        {type.availableAmount > 0 && addVat(type.fromPrice) > 0 && (
          <div className=" font-bold text-lg">
            {t('container_from_price', {
              price: addVat(type.fromPrice).toLocaleString(i18n.language, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }),
              currency: Currencies.getCodeByValue(type.currency),
            })}{' '}
            <div className="text-sm font-normal text-end text-gray-400">
              {' '}
              {t('incl_vat')}
            </div>
          </div>
        )}
      </div>
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div className="text-sm line-clamp-1">{type.description}</div>
      </div>
      <div className="w-full flex items-end">
        <div className="text-sm mt-2" style={{ color: '#BF4B30' }}>
          <span style={{ whiteSpace: 'nowrap' }}>
            {type.availableAmount} {t('units_available')}
          </span>
        </div>
      </div>
    </div>
  );

  function setSelectedSizeAndLevel(sizeType) {
    setSelectedSize(sizeType);
    for (let index = 0; index < sizeType.levelPrice.length; index++) {
      const price = sizeType.levelPrice[index];
      if (price != null && price > 0) {
        setSelectedLevel(index);
        break;
      }
    }
  }
}
